import { ConfigProvider } from 'antd'
import ru from 'antd/es/locale/ru_RU'
import type { ReactNode } from 'react'

export const withAntd = (component: () => ReactNode) => () => (
  <ConfigProvider locale={ru}>
    {component()}
  </ConfigProvider>
)
